import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLanguage } from "@/lib/LanguageContext";

const FAQSection = () => {
  const { t } = useLanguage();

  const faqs = [
    { id: "item-1", question: t("faq.q1"), answer: t("faq.a1") },
    { id: "item-2", question: t("faq.q2"), answer: t("faq.a2") },
    { id: "item-3", question: t("faq.q3"), answer: t("faq.a3") },
  ];

  return (
    <section className="max-w-7xl mx-auto px-6 py-24">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-center mb-16"
      >
        <h2
          className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-4"
          style={{ fontFamily: 'Inter, sans-serif', letterSpacing: '-0.03em' }}
        >
          {t("faq.title")}
        </h2>
      </motion.div>

      <div className="max-w-3xl mx-auto">
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map(({ id, question, answer }) => (
            <AccordionItem key={id} value={id} className="glass-card rounded-xl border-none px-6">
              <AccordionTrigger className="text-white hover:no-underline py-6">
                <span className="text-left font-semibold">{question}</span>
              </AccordionTrigger>
              <AccordionContent className="text-white/60 pb-6">
                {answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
